// Types and small helpers shared by the users list (users.ts) and the
// add/edit user page (user-form.ts).
import { t } from '../ui/lang';
/** Display labels for each role — used by badges and the role dropdown. */
const ROLE_LABEL_KEYS = {
    superadmin: 'users.role_superadmin',
    admin: 'users.role_admin',
    senior_operator: 'users.role_senior_operator',
    operator: 'users.role_operator',
};
export function roleLabel(role) {
    const key = ROLE_LABEL_KEYS[role];
    return key ? t(key) : role;
}
export function esc(s) {
    return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
export function setPageTitle(title) {
    const el = document.getElementById('page-title');
    if (el)
        el.textContent = title;
}
export function showErr(el, msg) {
    el.textContent = msg;
    el.style.display = 'block';
}
